import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import "../styles/Navbar.css";
import Logo from "../images/sujaramaha_logo.png";
import useClickSound from "../../Hooks/useClickSound";

export default function Navbar() {
  const location = useLocation();
  const playClick = useClickSound();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (path) => {
        setMenuOpen(false);

    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <>
      {/* DESKTOP NAVBAR (UNCHANGED) */}
          <header className="navbar" role="banner">
              <div className="navbar-container">

                  {/* LOGO + BRAND */}

                  <div className="navbar-logo navbar-logo-intro">
                      <NavLink to="/" onClick={() => {
                          playClick(); // 🔊 sound only here //
                          handleNavClick("/")
                      }}
                          aria-label="Sujaramaha Enterprises Home">
                          <img src={Logo} alt="Sujaramaha Enterprises logo"
                              className="navbar-logo-img"
                              loading="eager"
                              decoding="async" />
            </NavLink>
            <div className="brand-text">
              <span className="brand-name">Sujaramaha Enterprises</span>
              <span className="brand-tagline">A Legacy of Trust</span>
            </div>
          </div>

                  {/* NAVIGATION */}

                  <nav className="navbar-menu desktop-menu" role="navigation" aria-label="Sujaramaha Enterprises Main navigation">
            <ul>
                          <li><NavLink to="/" className={({ isActive }) =>isActive ? "nav-link active" : "nav-link"} onClick={() => handleNavClick("/")}>Home</NavLink></li>
                          <li><NavLink to="/about" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={() => handleNavClick("/about")}>About Us</NavLink></li>
                          <li><NavLink to="/services" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={() => handleNavClick("/services")}>Services</NavLink></li>
                          <li><NavLink to="/careers" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={() => handleNavClick("/careers")}>Careers</NavLink></li>
            </ul>
          </nav>

          <div className="navbar-cta">
                      <NavLink to="/contact" onClick={() => handleNavClick("/contact")} className="cta-btn" aria-label="Contact Sujaramaha Enterprises">Contact Us →</NavLink>
          </div>

          {/* HAMBURGER */}
          <button
            className="navbar-hamburger"
            onClick={() => setMenuOpen(true)}
                      aria-label="Sujaramaha Enterprises Open menu"
          >
            ☰
          </button>
        </div>
      </header>

      {/* FULL SCREEN MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-drawer">

                  {/* TOP BAR */}

                  {/*<div className="mobile-drawer-header">
                      <img src={Logo} alt="Logo" />

                      <NavLink
                          to="/contact"
                          className="drawer-cta"
                          onClick={() => handleNavClick("/contact")}
                      >
                          Contact Us →
                      </NavLink>

                      <button
                          className="drawer-close"
                          aria-label="Close menu"
                          onClick={() => setMenuOpen(false)}
                      >
                          ✕
                      </button>
                  </div>*/}

                  <div className="mobile-drawer-header">

                      {/* BRAND (same as desktop) */}
                      <div className="navbar-logo">
                          <img
                              src={Logo}
                              alt="Sujaramaha Enterprises logo"
                              width="42"
                              height="42"
                          />
                          <div className="brand-text">
                              <span className="brand-name">Sujaramaha Enterprises</span>
                              <span className="brand-tagline">A Legacy of Trust</span>
                          </div>
                      </div>

                      {/* RIGHT ACTIONS */}
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <NavLink
                              to="/contact"
                              className="drawer-cta"
                              onClick={() => handleNavClick("/contact")}
                          >
                              Contact
                          </NavLink>

                          <button
                              className="drawer-close"
                              aria-label="Close menu"
                              onClick={() => setMenuOpen(false)}
                          >
                              ✕
                          </button>
                      </div>

                  </div>


          {/* MENU ITEMS */}
                  <nav className="mobile-drawer-menu" aria-label="Sujaramaha Enterprises Mobile Main navigation">
                      <NavLink to="/"  onClick={() => handleNavClick("/")}>Home</NavLink>
                      <NavLink to="/about"  onClick={() => handleNavClick("/about")}>About Us</NavLink>
                      <NavLink to="/services"  onClick={() => handleNavClick("/services")}>Services</NavLink>
                      <NavLink to="/careers"  onClick={() => handleNavClick("/careers")}>Careers</NavLink>
                      <NavLink to="/contact"  onClick={() => handleNavClick("/contact")}>Contact</NavLink>
          </nav>

        </div>
      )}
    </>
  );
}
